import React from "react";
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: false };

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Serial Number',
      attr: 'serial_number',
      disableSort: true
    },
    {
      label: 'Invoice Number',
      attr: 'invoice_number',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Assigned At',
      attr: 'assigned_at',
      disableSort: true
    },
    {
      label: 'Invenytory Code',
      attr: 'inventory_code',
      disableSort: true
    },
    {
      label: 'Status',
      attr: 'status',
      disableSort: true
    }
  ]

  return <>
    <ListingComponent
      key={'PAGES.BatteriesListingPage.name'}
      listingMutation={getApi('batteries')}
      className="batteries-listing-page"
      contentHeading="Batteries - Results"
      headers={headers}
      recordsKey="batteries"
      params={props.defaultParams}
      searchBy={['ID', 'Serial Number']}
    />
  </>
};

export default Listing;
